import React, { useState, Fragment } from 'react';
import { CheckCircle2, Crown, TrendingUp, ShoppingBag, DollarSign, Download, ChevronDown, ChevronUp, X, AlertTriangle, Zap, Search, Star, Shield, Headphones, BarChart3, Megaphone, CreditCard, ArrowRight, XCircle, Wallet, Bell } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
interface SubscriptionTabProps {
  showToast: (msg: string) => void;
}
const PAYMENTS = [{
  id: 1,
  date: '15 Мар 2026',
  desc: 'Продление PRO',
  amount: '990 ₽',
  method: 'Visa ···4582',
  status: 'paid' as const
}, {
  id: 2,
  date: '15 Фев 2026',
  desc: 'Продление PRO',
  amount: '990 ₽',
  method: 'Visa ···4582',
  status: 'paid' as const
}, {
  id: 3,
  date: '15 Янв 2026',
  desc: 'Продление PRO',
  amount: '990 ₽',
  method: 'Visa ···4582',
  status: 'paid' as const
}, {
  id: 4,
  date: '15 Дек 2025',
  desc: 'Продление PRO',
  amount: '990 ₽',
  method: 'Visa ···4582',
  status: 'paid' as const
}, {
  id: 5,
  date: '15 Ноя 2025',
  desc: 'Переход на PRO',
  amount: '990 ₽',
  method: 'Visa ···4582',
  status: 'paid' as const
}];
const PLANS = [{
  id: 'free',
  name: 'Базовый',
  price: 0,
  priceLabel: '0 ₽',
  period: 'бесплатно',
  color: 'slate',
  features: {
    consultations: '5 / мес',
    commission: '25%',
    priority: 'Нет',
    limits: '3 услуги',
    advertising: 'Нет',
    analytics: 'Базовая',
    support: 'Email'
  },
  included: ['5 консультаций/мес', 'Комиссия 25%', 'Базовая аналитика', '3 услуги в каталоге'],
  missing: ['Приоритет в поиске', 'Продвижение', 'Расширенная аналитика']
}, {
  id: 'pro',
  name: 'PRO',
  price: 990,
  priceLabel: '990 ₽',
  period: '/мес',
  color: 'indigo',
  popular: true,
  features: {
    consultations: 'Безлимитно',
    commission: '15%',
    priority: 'Да',
    limits: '20 услуг',
    advertising: 'Базовое',
    analytics: 'Полная',
    support: 'Приоритетный'
  },
  included: ['Безлимитно консультаций', 'Комиссия 15%', 'Полная аналитика', '20 услуг', 'Приоритет в поиске', 'Базовое продвижение'],
  missing: ['Топ в каталоге', 'Персональный менеджер']
}, {
  id: 'top',
  name: 'TOP',
  price: 2490,
  priceLabel: '2 490 ₽',
  period: '/мес',
  color: 'amber',
  features: {
    consultations: 'Безлимитно',
    commission: '10%',
    priority: 'Топ',
    limits: 'Безлимитно',
    advertising: 'Премиум',
    analytics: 'Полная + AI',
    support: 'Персональный менеджер'
  },
  included: ['Безлимитно всё', 'Комиссия 10%', 'AI-аналитика', 'Топ в каталоге', 'Премиум продвижение', 'Персональный менеджер'],
  missing: []
}];
const FEATURE_ROWS = [{
  key: 'consultations',
  label: 'Консультации',
  icon: ShoppingBag
}, {
  key: 'commission',
  label: 'Комиссия',
  icon: DollarSign
}, {
  key: 'priority',
  label: 'Приоритет в поиске',
  icon: Search
}, {
  key: 'limits',
  label: 'Лимит услуг',
  icon: BarChart3
}, {
  key: 'advertising',
  label: 'Продвижение',
  icon: Megaphone
}, {
  key: 'analytics',
  label: 'Аналитика',
  icon: TrendingUp
}, {
  key: 'support',
  label: 'Поддержка',
  icon: Headphones
}];
export function SubscriptionTab({
  showToast
}: SubscriptionTabProps) {
  const [cancelConfirm, setCancelConfirm] = useState(false);
  const [expandedPayment, setExpandedPayment] = useState<number | null>(null);
  const [payFromBalance, setPayFromBalance] = useState(true);
  const currentPlan = PLANS.find(p => p.id === 'pro')!;
  const accountBalance = 24500;
  const togglePayment = (id: number) => {
    setExpandedPayment(prev => prev === id ? null : id);
  };
  return <div className="space-y-6" data-id="element-15487">
      {/* Header */}
      <div data-id="element-15488">
        <h2 className="text-2xl font-bold text-slate-900" data-id="element-15489">Подписка</h2>
        <p className="text-slate-500 text-sm mt-0.5" data-id="element-15490">Тариф, платежи, выгода</p>
      </div>

      {/* Current Plan */}
      <Card padding="md" className="border-indigo-200 bg-gradient-to-br from-indigo-50/50 to-purple-50/30" data-id="element-15491">
        <div className="flex flex-col sm:flex-row justify-between items-start gap-4 mb-5" data-id="element-15492">
          <div data-id="element-15493">
            <div className="flex items-center gap-2 mb-1" data-id="element-15494">
              <Crown className="w-5 h-5 text-indigo-600" data-id="element-15495" />
              <h3 className="text-xl font-bold text-indigo-900" data-id="element-15496">Тариф PRO</h3>
              <Badge variant="pro" data-id="element-15497">Активен</Badge>
            </div>
            <p className="text-sm text-indigo-700" data-id="element-15498">
              Следующее списание: 15 Апреля 2026 ·{' '}
              <span className="font-bold" data-id="element-15499">990 ₽/мес</span>
            </p>
          </div>
          <div className="flex gap-2 w-full sm:w-auto" data-id="element-15500">
            {cancelConfirm ? <div className="flex flex-col gap-2 p-3 bg-rose-50 border border-rose-200 rounded-xl w-full sm:w-auto" data-id="element-15501">
                <div className="flex items-center gap-2 text-sm text-rose-700 font-medium" data-id="element-15502">
                  <AlertTriangle className="w-4 h-4" data-id="element-15503" /> Вы потеряете:
                </div>
                <ul className="text-xs text-rose-600 space-y-0.5 ml-6" data-id="element-15504">
                  <li data-id="element-15505">• Приоритет в поиске</li>
                  <li data-id="element-15506">• Комиссия вырастет до 25%</li>
                  <li data-id="element-15507">• Лимит 5 консультаций/мес</li>
                </ul>
                <div className="flex gap-2 mt-1" data-id="element-15508">
                  <Button variant="outline" size="sm" className="border-rose-200 text-rose-600 hover:bg-rose-100" onClick={() => {
                setCancelConfirm(false);
                showToast('Подписка будет отменена в конце периода');
              }} data-id="element-15509">
                    Да, отменить
                  </Button>
                  <Button variant="outline" size="sm" onClick={() => setCancelConfirm(false)} data-id="element-15510">
                    Оставить
                  </Button>
                </div>
              </div> : <>
                <Button variant="outline" size="sm" className="text-slate-500 flex-1 sm:flex-none" onClick={() => setCancelConfirm(true)} data-id="element-15511">
                  Отменить
                </Button>
                <Button variant="primary" size="sm" className="flex-1 sm:flex-none" icon={<Zap className="w-4 h-4" data-id="element-15513" />} onClick={() => {
              const el = document.getElementById('plans-section');
              el?.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-15512">
                  Улучшить тариф
                </Button>
              </>}
          </div>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-5" data-id="element-15514">
          <div className="bg-white/70 rounded-xl p-3 border border-indigo-100" data-id="element-15515">
            <div className="text-[10px] text-indigo-500 font-medium uppercase tracking-wider mb-0.5" data-id="element-15516">
              Заказов за месяц
            </div>
            <div className="text-lg font-bold text-indigo-900 flex items-center gap-1" data-id="element-15517">
              +12 <TrendingUp className="w-4 h-4 text-emerald-500" data-id="element-15518" />
            </div>
          </div>
          <div className="bg-white/70 rounded-xl p-3 border border-indigo-100" data-id="element-15519">
            <div className="text-[10px] text-indigo-500 font-medium uppercase tracking-wider mb-0.5" data-id="element-15520">
              Доход за месяц
            </div>
            <div className="text-lg font-bold text-indigo-900" data-id="element-15521">68 400 ₽</div>
          </div>
          <div className="bg-white/70 rounded-xl p-3 border border-indigo-100" data-id="element-15522">
            <div className="text-[10px] text-indigo-500 font-medium uppercase tracking-wider mb-0.5" data-id="element-15523">
              Комиссия
            </div>
            <div className="text-lg font-bold text-indigo-900" data-id="element-15524">15%</div>
          </div>
          <div className="bg-white/70 rounded-xl p-3 border border-indigo-100" data-id="element-15525">
            <div className="text-[10px] text-indigo-500 font-medium uppercase tracking-wider mb-0.5" data-id="element-15526">
              Приоритет
            </div>
            <div className="text-lg font-bold text-emerald-600 flex items-center gap-1" data-id="element-15527">
              <CheckCircle2 className="w-4 h-4" data-id="element-15528" /> Да
            </div>
          </div>
        </div>

        {/* What's included */}
        <div className="pt-4 border-t border-indigo-100" data-id="element-15529">
          <div className="text-xs font-bold text-indigo-700 uppercase tracking-wider mb-2" data-id="element-15530">
            Что входит в PRO
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5" data-id="element-15531">
            {currentPlan.included.map(f => <div key={f} className="flex items-center gap-1.5 text-sm text-indigo-800" data-id="element-15532">
                <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500 shrink-0" data-id="element-15533" />{' '}
                {f}
              </div>)}
          </div>
        </div>
      </Card>

      {/* Payment Method & Notifications */}
      <Card padding="md" data-id="element-15534">
        <h3 className="font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-15535">
          <Wallet className="w-5 h-5 text-slate-400" data-id="element-15536" /> Способ оплаты подписки
        </h3>
        <div className="flex flex-col sm:flex-row gap-3 mb-4" data-id="element-15537">
          <button onClick={() => {
          setPayFromBalance(true);
          showToast('Подписка будет списываться с баланса');
        }} className={`flex-1 p-3 rounded-xl border text-left transition-colors ${payFromBalance ? 'border-indigo-500 bg-indigo-50/50 ring-1 ring-indigo-500' : 'border-slate-200 hover:border-slate-300'}`} data-id="element-15538">
            <div className="flex items-center gap-2 mb-1" data-id="element-15539">
              <Wallet className="w-4 h-4 text-indigo-600" data-id="element-15540" />
              <span className="font-bold text-sm text-slate-900" data-id="element-15541">
                С баланса
              </span>
              {payFromBalance && <Badge variant="success" size="sm" data-id="element-15542">
                  Активно
                </Badge>}
            </div>
            <div className="text-xs text-slate-500" data-id="element-15543">
              Баланс:{' '}
              <span className="font-bold text-slate-700" data-id="element-15544">
                {new Intl.NumberFormat('ru-RU').format(accountBalance)} ₽
              </span>
            </div>
          </button>
          <button onClick={() => {
          setPayFromBalance(false);
          showToast('Подписка будет списываться с карты');
        }} className={`flex-1 p-3 rounded-xl border text-left transition-colors ${!payFromBalance ? 'border-indigo-500 bg-indigo-50/50 ring-1 ring-indigo-500' : 'border-slate-200 hover:border-slate-300'}`} data-id="element-15545">
            <div className="flex items-center gap-2 mb-1" data-id="element-15546">
              <CreditCard className="w-4 h-4 text-slate-600" data-id="element-15547" />
              <span className="font-bold text-sm text-slate-900" data-id="element-15548">С карты</span>
              {!payFromBalance && <Badge variant="success" size="sm" data-id="element-15549">
                  Активно
                </Badge>}
            </div>
            <div className="text-xs text-slate-500" data-id="element-15550">Visa •••• 4582</div>
          </button>
        </div>
        <div className="flex items-start gap-2 p-3 bg-amber-50 border border-amber-100 rounded-lg" data-id="element-15551">
          <Bell className="w-4 h-4 text-amber-500 mt-0.5 shrink-0" data-id="element-15552" />
          <div className="text-xs text-amber-700" data-id="element-15553">
            <span className="font-medium" data-id="element-15554">Уведомление:</span> за 3 дня до
            списания вы получите напоминание. Следующее списание{' '}
            <span className="font-bold" data-id="element-15555">990 ₽</span> — 15 Апреля 2026{' '}
            {payFromBalance ? 'с баланса' : 'с карты'}.
          </div>
        </div>
      </Card>

      {/* Why Upgrade */}
      <Card padding="md" className="border-amber-200 bg-amber-50/30" data-id="element-15556">
        <div className="flex items-center gap-2 mb-3" data-id="element-15557">
          <Zap className="w-5 h-5 text-amber-600" data-id="element-15558" />
          <h3 className="font-bold text-slate-900" data-id="element-15559">
            Почему стоит улучшить тариф
          </h3>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-id="element-15560">
          {[{
          stat: '+40%',
          label: 'заказов',
          desc: 'Астрологи на TOP получают на 40% больше заказов'
        }, {
          stat: 'Топ-3',
          label: 'в каталоге',
          desc: 'Ваш профиль показывается первым в поиске'
        }, {
          stat: '-10%',
          label: 'комиссия',
          desc: 'Экономия до 15% на комиссии с каждого заказа'
        }].map(item => <div key={item.label} className="bg-white rounded-xl p-3 border border-amber-100" data-id="element-15561">
              <div className="text-2xl font-bold text-amber-700 mb-0.5" data-id="element-15562">
                {item.stat}
              </div>
              <div className="text-sm font-medium text-slate-900 mb-0.5" data-id="element-15563">
                {item.label}
              </div>
              <div className="text-xs text-slate-500" data-id="element-15564">{item.desc}</div>
            </div>)}
        </div>
        <Button variant="primary" size="sm" className="mt-4 bg-amber-600 hover:bg-amber-700" icon={<ArrowRight className="w-4 h-4" data-id="element-15566" />} onClick={() => {
        const el = document.getElementById('plans-section');
        el?.scrollIntoView({
          behavior: 'smooth'
        });
      }} data-id="element-15565">
          Перейти на TOP
        </Button>
      </Card>

      {/* Plan Comparison */}
      <div id="plans-section" data-id="element-15567">
        <h3 className="font-bold text-slate-900 text-lg mb-4" data-id="element-15568">Выбор тарифа</h3>

        {/* Mobile: Cards */}
        <div className="sm:hidden space-y-3" data-id="element-15569">
          {PLANS.map(plan => {
          const isCurrent = plan.id === 'pro';
          return <Card key={plan.id} padding="md" className={`${isCurrent ? 'border-indigo-500 ring-1 ring-indigo-500' : 'border-slate-200'} ${plan.id === 'top' ? 'border-amber-400' : ''}`} data-id="element-15570">
                <div className="flex items-center justify-between mb-2" data-id="element-15571">
                  <div className="flex items-center gap-2" data-id="element-15572">
                    <span className="font-bold text-lg text-slate-900" data-id="element-15573">
                      {plan.name}
                    </span>
                    {isCurrent && <Badge variant="pro" size="sm" data-id="element-15574">
                        Текущий
                      </Badge>}
                    {plan.id === 'top' && !isCurrent && <Badge variant="warning" size="sm" data-id="element-15575">
                        Популярный
                      </Badge>}
                  </div>
                </div>
                <div className="mb-3" data-id="element-15576">
                  <span className="text-2xl font-bold text-slate-900" data-id="element-15577">
                    {plan.priceLabel}
                  </span>
                  <span className="text-sm text-slate-500" data-id="element-15578">{plan.period}</span>
                </div>
                <ul className="space-y-1.5 mb-4" data-id="element-15579">
                  {plan.included.map(f => <li key={f} className="text-sm text-slate-700 flex items-center gap-1.5" data-id="element-15580">
                      <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500 shrink-0" data-id="element-15581" />{' '}
                      {f}
                    </li>)}
                  {plan.missing.map(f => <li key={f} className="text-sm text-slate-400 flex items-center gap-1.5" data-id="element-15582">
                      <XCircle className="w-3.5 h-3.5 text-slate-300 shrink-0" data-id="element-15583" />{' '}
                      {f}
                    </li>)}
                </ul>
                {isCurrent ? <div className="text-center text-sm text-indigo-600 font-medium py-2" data-id="element-15584">
                    Ваш текущий тариф
                  </div> : <Button variant={plan.id === 'top' ? 'primary' : 'outline'} fullWidth onClick={() => showToast(`Переход на ${plan.name}`)} data-id="element-15585">
                    {plan.price > 990 ? 'Улучшить' : plan.price === 0 ? 'Перейти' : 'Выбрать'}
                  </Button>}
              </Card>;
        })}
        </div>

        {/* Desktop: Comparison Table */}
        <Card padding="none" className="hidden sm:block overflow-hidden" data-id="element-15586">
          <table className="w-full text-sm" data-id="element-15587">
            <thead data-id="element-15588">
              <tr className="border-b border-slate-100" data-id="element-15589">
                <th className="text-left px-4 py-3 text-xs font-medium text-slate-500 w-1/4" data-id="element-15590">
                  Возможность
                </th>
                {PLANS.map(plan => <th key={plan.id} className={`px-4 py-3 text-center ${plan.id === 'pro' ? 'bg-indigo-50/50' : plan.id === 'top' ? 'bg-amber-50/50' : ''}`} data-id="element-15591">
                    <div className="font-bold text-slate-900" data-id="element-15592">{plan.name}</div>
                    <div className="text-xs text-slate-500 mt-0.5" data-id="element-15593">
                      {plan.priceLabel}
                      {plan.period}
                    </div>
                    {plan.id === 'pro' && <Badge variant="pro" size="sm" className="mt-1" data-id="element-15594">
                        Текущий
                      </Badge>}
                  </th>)}
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-15595">
              {FEATURE_ROWS.map(row => <tr key={row.key} className="hover:bg-slate-50/50" data-id="element-15596">
                  <td className="px-4 py-2.5 text-slate-700 flex items-center gap-2" data-id="element-15597">
                    <row.icon className="w-4 h-4 text-slate-400" data-id="element-15598" /> {row.label}
                  </td>
                  {PLANS.map(plan => <td key={plan.id} className={`px-4 py-2.5 text-center font-medium ${plan.id === 'pro' ? 'bg-indigo-50/30 text-indigo-700' : plan.id === 'top' ? 'bg-amber-50/30 text-amber-700' : 'text-slate-600'}`} data-id="element-15599">
                      {(plan.features as Record<string, string>)[row.key]}
                    </td>)}
                </tr>)}
            </tbody>
            <tfoot data-id="element-15600">
              <tr className="border-t border-slate-200" data-id="element-15601">
                <td className="px-4 py-3" data-id="element-15602"></td>
                {PLANS.map(plan => <td key={plan.id} className={`px-4 py-3 text-center ${plan.id === 'pro' ? 'bg-indigo-50/30' : plan.id === 'top' ? 'bg-amber-50/30' : ''}`} data-id="element-15603">
                    {plan.id === 'pro' ? <span className="text-sm text-indigo-600 font-medium" data-id="element-15604">
                        Текущий тариф
                      </span> : <Button variant={plan.id === 'top' ? 'primary' : 'outline'} size="sm" fullWidth onClick={() => showToast(`Переход на ${plan.name}`)} data-id="element-15605">
                        {plan.price > 990 ? 'Улучшить' : 'Выбрать'}
                      </Button>}
                  </td>)}
              </tr>
            </tfoot>
          </table>
        </Card>
      </div>

      {/* Payment History */}
      <div data-id="element-15606">
        <h3 className="font-bold text-slate-900 text-lg mb-4" data-id="element-15607">
          История платежей
        </h3>
        <Card padding="none" className="overflow-hidden" data-id="element-15608">
          {/* Desktop */}
          <div className="hidden sm:block" data-id="element-15609">
            <table className="w-full text-sm text-left" data-id="element-15610">
              <thead className="bg-slate-50 text-slate-500 border-b border-slate-100" data-id="element-15611">
                <tr data-id="element-15612">
                  <th className="px-4 py-2.5 font-medium text-xs" data-id="element-15613">Дата</th>
                  <th className="px-4 py-2.5 font-medium text-xs" data-id="element-15614">Описание</th>
                  <th className="px-4 py-2.5 font-medium text-xs" data-id="element-15615">Способ</th>
                  <th className="px-4 py-2.5 font-medium text-xs" data-id="element-15616">Сумма</th>
                  <th className="px-4 py-2.5 font-medium text-xs" data-id="element-15617">Статус</th>
                  <th className="px-4 py-2.5 font-medium text-xs" data-id="element-15618"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-15619">
                {PAYMENTS.map(p => <Fragment key={p.id} data-id="element-15620">
                    <tr className="hover:bg-slate-50 cursor-pointer" onClick={() => togglePayment(p.id)} data-id="element-15621">
                      <td className="px-4 py-2.5 text-slate-600 text-xs" data-id="element-15622">
                        {p.date}
                      </td>
                      <td className="px-4 py-2.5 font-medium text-slate-900 text-xs" data-id="element-15623">
                        {p.desc}
                      </td>
                      <td className="px-4 py-2.5 text-slate-500 text-xs" data-id="element-15624">
                        {p.method}
                      </td>
                      <td className="px-4 py-2.5 text-slate-900 text-xs font-medium" data-id="element-15625">
                        {p.amount}
                      </td>
                      <td className="px-4 py-2.5" data-id="element-15626">
                        <Badge variant="success" size="sm" data-id="element-15627">
                          Оплачено
                        </Badge>
                      </td>
                      <td className="px-4 py-2.5" data-id="element-15628">
                        {expandedPayment === p.id ? <ChevronUp className="w-4 h-4 text-slate-400" data-id="element-15629" /> : <ChevronDown className="w-4 h-4 text-slate-400" data-id="element-15630" />}
                      </td>
                    </tr>
                    {expandedPayment === p.id && <tr data-id="element-15631">
                        <td colSpan={6} className="px-4 py-3 bg-slate-50" data-id="element-15632">
                          <div className="flex items-center justify-between" data-id="element-15633">
                            <div className="text-xs text-slate-500 space-y-1" data-id="element-15634">
                              <div data-id="element-15635">
                                Чек №{1000 + p.id} · {p.date}
                              </div>
                              <div data-id="element-15636">Способ оплаты: {p.method}</div>
                              <div data-id="element-15637">Тариф: PRO · Период: 1 месяц</div>
                            </div>
                            <Button variant="outline" size="sm" icon={<Download className="w-3.5 h-3.5" data-id="element-15639" />} onClick={e => {
                        e.stopPropagation();
                        showToast('Чек скачан ✓');
                      }} data-id="element-15638">
                              Скачать чек
                            </Button>
                          </div>
                        </td>
                      </tr>}
                  </Fragment>)}
              </tbody>
            </table>
          </div>

          {/* Mobile */}
          <div className="sm:hidden divide-y divide-slate-100" data-id="element-15640">
            {PAYMENTS.map(p => <div key={p.id} data-id="element-15641">
                <div className="p-3 flex justify-between items-center cursor-pointer" onClick={() => togglePayment(p.id)} data-id="element-15642">
                  <div data-id="element-15643">
                    <div className="text-sm font-medium text-slate-900" data-id="element-15644">
                      {p.desc}
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-15645">
                      {p.date} · {p.method}
                    </div>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-15646">
                    <div className="text-right" data-id="element-15647">
                      <div className="text-sm font-bold text-slate-900" data-id="element-15648">
                        {p.amount}
                      </div>
                      <Badge variant="success" size="sm" data-id="element-15649">
                        Оплачено
                      </Badge>
                    </div>
                    {expandedPayment === p.id ? <ChevronUp className="w-4 h-4 text-slate-400" data-id="element-15650" /> : <ChevronDown className="w-4 h-4 text-slate-400" data-id="element-15651" />}
                  </div>
                </div>
                {expandedPayment === p.id && <div className="px-3 pb-3" data-id="element-15652">
                    <div className="bg-slate-50 rounded-lg p-3 space-y-2" data-id="element-15653">
                      <div className="text-xs text-slate-500" data-id="element-15654">
                        Чек №{1000 + p.id} · Тариф PRO · 1 месяц
                      </div>
                      <Button variant="outline" size="sm" fullWidth icon={<Download className="w-3.5 h-3.5" data-id="element-15656" />} onClick={() => showToast('Чек скачан ✓')} data-id="element-15655">
                        Скачать чек
                      </Button>
                    </div>
                  </div>}
              </div>)}
          </div>
        </Card>
      </div>
    </div>;
}